import { Button } from '@mui/material'
import WarningIcon from '@mui/icons-material/Warning'
import { useNavigate, useLocation } from 'react-router-dom'
import { CONTROLS } from '~/components/Charts/chrome/chartChrome'

export function ResetSettingsButton() {
  const navigate = useNavigate()
  const { pathname } = useLocation()
  return (
    <Button
      color="warning"
      variant="outlined"
      startIcon={<WarningIcon />}
      onClick={() => navigate(pathname, { replace: true })}
    >
      {CONTROLS.resetSettings}
    </Button>
  )
}
